var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8694_30635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8694_30635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13.9996V7L17 3H5C4.45 3 3.979 3.19567 3.587 3.587C3.19567 3.979 3 4.45 3 5V19C3 19.55 3.19567 20.021 3.587 20.413C3.979 20.8043 4.45 21 5 21H13.9997C13.563 20.4186 13.25 19.7389 13.1 19H5V5H16.15L19 7.85V13.1C19.7389 13.2499 20.4186 13.5629 21 13.9996ZM14.8721 14.0989C14.7343 13.6433 14.4853 13.2353 14.125 12.875C13.5417 12.2917 12.8333 12 12 12C11.1667 12 10.4583 12.2917 9.875 12.875C9.29167 13.4583 9 14.1667 9 15C9 15.8333 9.29167 16.5417 9.875 17.125C10.4583 17.7083 11.1667 18 12 18C12.3571 18 12.6913 17.9464 13.0025 17.8393C13.0503 16.327 13.7696 14.9841 14.8721 14.0989ZM15 10H6V6H15V10Z",
    fill: "#858585"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8694_30635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7706 18.2152L20.9429 17.5712C21.1443 16.8195 21.2453 16.4438 21.1696 16.1185C21.1096 15.8617 20.9749 15.6284 20.7823 15.4482C20.5386 15.2198 20.1626 15.1192 19.4109 14.9178C18.6593 14.7162 18.2833 14.6155 17.9583 14.6912C17.7014 14.7511 17.4682 14.8859 17.2879 15.0785C17.0923 15.2872 16.9903 15.5928 16.8386 16.1482L16.7573 16.4498L16.5849 17.0938C16.3833 17.8455 16.2826 18.2212 16.3583 18.5465C16.4183 18.8033 16.553 19.0366 16.7456 19.2168C16.9893 19.4452 17.3653 19.5458 18.1169 19.7475C18.7943 19.9288 19.1666 20.0285 19.4716 19.9908C19.5049 19.9868 19.5376 19.9808 19.5696 19.9735C19.8264 19.9137 20.0596 19.7792 20.2399 19.5868C20.4683 19.3428 20.5689 18.9668 20.7706 18.2152Z",
    stroke: "#858585",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.4717 19.9914C19.402 20.2049 19.2795 20.3973 19.1157 20.5508C18.872 20.7791 18.496 20.8798 17.7443 21.0811C16.9927 21.2824 16.6167 21.3834 16.2917 21.3074C16.0349 21.2476 15.8016 21.1129 15.6213 20.9204C15.393 20.6768 15.292 20.3008 15.0907 19.5491L14.9183 18.9051C14.7167 18.1534 14.616 17.7774 14.6917 17.4524C14.7516 17.1956 14.8864 16.9623 15.079 16.7821C15.3227 16.5538 15.6987 16.4531 16.4503 16.2514C16.5923 16.2134 16.7213 16.1788 16.8387 16.1484",
    stroke: "#858585",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9257 17.332L19.5357 17.7634",
    stroke: "#858585",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.6666 18.2988L18.6326 18.5575",
    stroke: "#858585",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8694_30635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveNotes);
export default __webpack_public_path__ + "static/media/save-notes.ac0f0b09.svg";
export { ForwardRef as ReactComponent };